import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlansService {
  private planApiUrl = `${environment.apiUrl}/planes`;

  constructor(private http: HttpClient) {}

  obtenerPlan(): Observable<any[]> {
    return this.http.get<any[]>(this.planApiUrl);
  }
}
